import React from 'react';
import ReactDOM from 'react-dom';
import App from './routes/App';
import reportWebVitals from './reportWebVitals';
import './assets/styles/global.sass';

ReactDOM.render(
    <App />, 
    document.getElementById('root')
);

reportWebVitals();